import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import FacilitiesList from "../../components/maintenance/FacilitiesList";
import { STARTING_PAGE } from "../../constants/constants";
import {
  fetchFacilities,
  fetchFacilitiesSuccess,
  fetchFacilitiesFailure,
  fetchFacilityTypes,
  fetchFacilityTypesSuccess,
  fetchFacilityTypesFailure,
  fetchMaintenanceLocations,
  fetchMaintenanceLocationsSuccess,
  fetchMaintenanceLocationsFailure,
} from "../../store/maintenance/actions";

const FacilitiesListContainer = ({
  facilities,
  facilityTypes,
  locations,
  fetchFacilities,
  fetchFacilityTypes,
  fetchMaintenanceLocations,
}) => {
  const [currentPage, setCurrentPage] = useState(STARTING_PAGE);
  const [filters, setFilters] = useState({
    facilityType: null,
    location: null,
    status: null,
    search: null,
  });

  useEffect(() => {
    fetchFacilities(STARTING_PAGE);
    fetchFacilityTypes();
    fetchMaintenanceLocations();
  }, [fetchFacilities, fetchFacilityTypes, fetchMaintenanceLocations]);

  const handleFilter = useCallback(
    (newFilters) => {
      setFilters(newFilters);
      setCurrentPage(STARTING_PAGE);
      fetchFacilities(
        STARTING_PAGE,
        newFilters.facilityType || null,
        newFilters.location || null,
        newFilters.status || null,
        newFilters.search || null
      );
    },
    [fetchFacilities]
  );

  const handlePageRequest = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== currentPage) {
        setCurrentPage(page);
        fetchFacilities(
          page,
          filters.facilityType || null,
          filters.location || null,
          filters.status || null,
          filters.search || null
        );
      }
    },
    [currentPage, filters, fetchFacilities]
  );

  return (
    <>
      <FacilitiesList
        facilities={facilities.list}
        facilityTypes={facilityTypes.list}
        locations={locations.list}
        loading={facilities.loading}
        error={facilities.error}
        onFilter={handleFilter}
      />
      {facilities.pages > 1 && (
        <ReactPaginate
          pageCount={facilities.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handlePageRequest}
          initialPage={currentPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={currentPage - 1}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  facilities: state.maintenance.facilities,
  facilityTypes: state.maintenance.facilityTypes,
  locations: state.maintenance.locations,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFacilities: (page, facilityType, location, status, search) => {
    dispatch(fetchFacilities(page, facilityType, location, status, search)).payload.then(
      (response) => {
        dispatch(fetchFacilitiesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchFacilitiesFailure(error.response?.data || error));
      }
    );
  },
  fetchFacilityTypes: () => {
    dispatch(fetchFacilityTypes(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchFacilityTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchFacilityTypesFailure(error.response?.data || error));
      }
    );
  },
  fetchMaintenanceLocations: () => {
    dispatch(fetchMaintenanceLocations(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMaintenanceLocationsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMaintenanceLocationsFailure(error.response?.data || error));
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FacilitiesListContainer);
